import { ReceiptText } from 'lucide-react'
import { formatCurrency } from '@/common/utils/formatters'
import { ManualEntryProposalShowData } from '../../../types/maintenanceManualEntryProposal.type'
import ProposalAwareResumeItem from '../../ProposalAwareResumeItem'
import ProposalObjectives from '../../ProposalObjectives'

type Props = {
  proposal: ManualEntryProposalShowData
}

const ExecutionSentProposalExtras = ({ proposal }: Props) => {
  const content = proposal.proposal_content
  const objectives = proposal.manual_entry?.forwarding?.directive_entry?.objectives ?? []

  const originalTotal = content?.original_total_value != null ? Number(content.original_total_value) : undefined
  const newTotal = content?.new_total_value != null ? Number(content.new_total_value) : undefined

  return (
    <>
      <div className="flex flex-wrap gap-x-8 gap-y-3">
        <ProposalAwareResumeItem
          label="Valor"
          originalValue={originalTotal ?? newTotal ?? 0}
          newValue={newTotal != null && originalTotal != null && newTotal !== originalTotal ? newTotal : null}
          differencePercentage={content?.difference_percentage}
          format={formatCurrency}
        />
      </div>

      {objectives.length > 0 && (
        <div className="flex flex-col gap-3 pt-4 border-t border-white-200">
          <div className="flex items-center gap-2">
            <ReceiptText className="size-4 text-white-400" strokeWidth={1.5} />
            <p className="text-sm font-medium">Objetos de manutenção</p>
          </div>

          <ProposalObjectives objectives={objectives} content={content ?? null} />
        </div>
      )}
    </>
  )
}

export default ExecutionSentProposalExtras
